import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

import { EnumButtonSizes } from '@/enums/enums'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'

import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'

import messages from '@/utils/messages'


export default /*@__PURE__*/_defineComponent({
  __name: 'BtnPublishFocusedInstitutional',
  setup(__props) {

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()

/**
 * ✅ SHOW PUBLICAR
 */
const showPublishButton = computed(() => {
  return (
    authStore.currentUserCanCreateInstitutional &&
    institutionalStore.institutionalDetail?.status ===
      CONST_INSTITUTIONAL_STATUS.APPROVED.id
  )
})

/**
 * ✅ SHOW REPUBLICAR
 */
const showRepublishButton = computed(() => {
  return (
    authStore.currentUserCanCreateInstitutional &&
    institutionalStore.institutionalDetail?.status ===
      CONST_INSTITUTIONAL_STATUS.REAPPROVED.id
  )
})

/**
 * ✅ PUBLICAR
 */
const onPublishInstitutional = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    await institutionalStore.publishInstitutional(id)

    messages.showSuccessMsg('Cadastro publicado com sucesso!')

  } catch (error) {
    console.error(error)
    messages.showErrorMsg('Erro ao publicar cadastro.')
  } finally {
    pagesUtilStore.showLoading = false
  }
}

/**
 * ✅ REPUBLICAR
 */
const onRepublishInstitutional = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    await institutionalStore.republishInstitutional(id)

    messages.showSuccessMsg('Cadastro republicado com sucesso!')

  } catch (error) {
    console.error(error)
    messages.showErrorMsg('Erro ao republicar cadastro.')
  } finally {
    pagesUtilStore.showLoading = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (showPublishButton.value)
      ? (_openBlock(), _createBlock(_component_c_q_btn, {
          key: 0,
          id: "btn-publish-institutional",
          propBtnLabel: "Publicar Cadastro",
          propBtnFunction: onPublishInstitutional,
          propBtnTransparent: false,
          propBtnSize: _unref(EnumButtonSizes).LARGE_1
        }, null, 8, ["propBtnSize"]))
      : _createCommentVNode("", true),
    (showRepublishButton.value)
      ? (_openBlock(), _createBlock(_component_c_q_btn, {
          key: 1,
          id: "btn-republish-institutional",
          propBtnLabel: "Republicar Cadastro",
          propBtnFunction: onRepublishInstitutional,
          propBtnTransparent: false,
          propBtnSize: _unref(EnumButtonSizes).LARGE_1
        }, null, 8, ["propBtnSize"]))
      : _createCommentVNode("", true)
  ]))
}
}

})